// extracted by css-extract-rspack-plugin
export default {"cls1":"Thumbnail-cls1_Dpd","cls2":"Thumbnail-cls2_jvz Thumbnail-cls1_Dpd"};